<template>
  <div class="Site PageBox" style="padding-top: 0;background-color: var(--background-main)">
    <div class="Login ScrollBox">
      <van-nav-bar
        :border="false"
        @click-left="$router.go(-1)"
        @click-right="$langList.length>1?$router.push('/language'):false"
      >
        <template #left>
          <van-icon name="cross" />
        </template>
        <template v-if="$langList.length>1" #right>
          <van-icon :name="`./static/icon/${Theme}/icon-language.svg`" />
        </template>
      </van-nav-bar>
      <van-tabs v-model="tabsIndex" color="var(--color-active)" title-active-color="var(--color-active)" @change="changeTabs">
        <van-tab v-if="InitData.setting.reg_phone==1" :title="$t('register.text[6]')" name="phone" />
        <van-tab v-if="InitData.setting.reg_email==1" :title="$t('register.text[7]')" name="mail" />
      </van-tabs>
      <van-form class="mt20" @submit="onSubmit">
        <input
          type="text"
          autocomplete="off"
          style="position: absolute;opacity:0;z-index:-1"
        />
        <input
          type="password"
          autocomplete="off"
          style="position: absolute;opacity:0;z-index:-1"
        />
        <van-field
          v-if="tabsIndex=='phone'"
          v-model.trim="postData.username"
          :border="false"
          left-icon="phone"
          :placeholder="$t('register.placeholder[0]')"
          clearable
          autocomplete="off"
          key="phone"
          label-width="auto"
        >
          <template #label>
            <van-dropdown-menu>
              <van-dropdown-item :title="`+${postData.dest}`" ref="DropdownItem">
                <template>
                  <ul>
                    <li v-for="(item,index) in areaList" :key="index" :class="{on:postData.dest==item.id}" @click="postData.dest=item.id,$refs.DropdownItem.toggle()">+{{item.id}}&#12288;{{item.name}}</li>
                  </ul>
                </template>
              </van-dropdown-item>
            </van-dropdown-menu>
          </template>
        </van-field>
        <van-field
          v-if="tabsIndex=='mail'"
          left-icon="comment"
          v-model.trim="postData.username"
          :placeholder="$t('Register[0]')"
          clearable
          autocomplete="off"
          :border="false"
          key="email"
        />
        <!-- <van-field
          left-icon="coupon"
          v-model.trim="postData.code"
          autocomplete="off"
          type="digit"
          :placeholder="$t('register.placeholder[6]')"
          clearable
          :border="false"
        >
          <template #button>
            <van-image width="100" height="34" :src="codeImg" style="display: block;cursor: pointer;" @click="getCode" />
          </template>
        </van-field> -->
        <!-- <van-field
          v-if="tabsIndex=='phone'&&InitData.setting.is_sms==1"
          left-icon="coupon"
          v-model.trim="postData.smscode"
          autocomplete="off"
          type="digit"
          :placeholder="$t('register.placeholder[1]')"
          clearable
          :border="false"
        >
          <template #button>
            <van-button size="mini" type="info" :color="isSendCode?'var(--color-assist)':''" round native-type="button" :disabled="isSendCode" @click="getSmsCode">{{$t('register.text[2]')}}{{isSendCode?`(${sendTime}s)`:''}}</van-button>
          </template>
        </van-field>
        <van-field
          v-if="tabsIndex=='mail'&&InitData.setting.is_mail==1"
          left-icon="coupon"
          v-model.trim="postData.smscode"
          autocomplete="off"
          type="digit"
          :placeholder="$t('Register[1][0]')"
          clearable
          :border="false"
        >
          <template #button>
            <van-button size="mini" type="info" :color="isSendCode?'var(--color-assist)':''" round native-type="button" :disabled="isSendCode" @click="getMailCode">{{$t('Register[1][1]')}}{{isSendCode?`(${sendTime}s)`:''}}</van-button>
          </template>
        </van-field> -->
        <van-field
          left-icon="lock"
          type="password"
          v-model.trim="postData.password"
          :placeholder="$t('register.placeholder[2]')"
          clearable
          autocomplete="off"
          :border="false"
        />
        <!-- <van-field
          left-icon="lock"
          type="password"
          v-model.trim="postData.re_password"
          :placeholder="$t('register.placeholder[3]')"
          clearable
          autocomplete="off"
          :border="false"
        /> -->
        <van-field
          left-icon="invitation"
          :readonly="recommendDis"
          v-model.trim="postData.recommend"
          :placeholder="$t('register.placeholder[4]')"
          clearable
          autocomplete="off"
          :border="false"
        />
        <div style="padding: 20px 16px">
          <van-button v-if="tabsIndex=='phone'&&InitData.setting.is_sms==1" size="large" block type="danger" :color="isSendCode?'var(--color-assist)':''" round native-type="button" :disabled="isSendCode" style="font-size: 16px;" @click="getSmsCode()">{{$t('register.text[8]')}}{{isSendCode?`(${sendTime}s)`:''}}</van-button>

          <van-button v-else-if="tabsIndex=='mail'&&InitData.setting.is_mail==1" size="large" block type="danger" :color="isSendCode?'var(--color-assist)':''" round native-type="button" :disabled="isSendCode" style="font-size: 16px;" @click="getMailCode()">{{$t('register.text[8]')}}{{isSendCode?`(${sendTime}s)`:''}}</van-button>

          <van-button v-else size="large" block type="danger" round :loading="isSubmit" :loading-text="$t('register.text[3]')" style="font-size: 16px;">{{$t('register.text[4]')}}</van-button>
          <van-button v-if="!isPlus" size="large" block plain color="var(--button-main)" round style="font-size: 16px;margin-top: 15px;" @click="$Util.OpenUrl(downUrl)">{{$t('appDown[0]')}}</van-button>
          <div class="bottom" style="margin-top: 30px;display: flex;justify-content: space-between;text-align: left">
            <router-link to="/login">{{$t('register.i18n[0]')}}<span class="href">{{$t('register.i18n[1]')}}</span></router-link>
            <router-link v-if="InitData.link.length" class="href" to="/line">{{$t('line')}}</router-link>
          </div>
          <div v-if="InitData.registrationTutorial" style="margin-top: 10px;text-align: left">
            <a class="href" href="javascript:;" @click="showPopup=true">{{$t('register.tips')}}</a>
          </div>
        </div>
      </van-form>
    </div>
    <div class="BrowserTips" v-show="showBrowserTips">
      <img :src="'./static/images/down-zy.png'" width="80%">
    </div>
    <van-popup
      v-model="showPopup"
      closeable
      position="bottom"
      class="disclaimer-box"
    >
      <h2>{{$t('register.tips')}}</h2>
      <div class="con" v-html="InitData.registrationTutorial"></div>
    </van-popup>
    <van-popup
      v-model="showVerify"
      position="right"
      style="height:100%;width:100%"
    >
      <div class="PageBox" style="background-color:var(--background-main);">
        <van-nav-bar
          fixed
          :border="false"
          left-arrow
          @click-left="showVerify=false"
        />
        <div class="ScrollBox">
          <div class="verify-box">
            <h2>{{tabsIndex=='phone'?$t('register.text[9]'):$t('register.text[10]')}}</h2>
            <p>{{tabsIndex=='phone'?$t('register.placeholder[1]'):$t('Register[1][0]')}}</p>
            <van-password-input
              :value="postData.smscode"
              :gutter="10"
              :focused="showKeyboard"
              :mask="false"
              @focus="showKeyboard = true"
            />
            <a class="btn" :class="{disabled:isSendCode}" href="javascript:;" @click="isSendCode?false:(tabsIndex=='phone'?getSmsCode():getMailCode())">{{$t('register.text[11]')}}{{isSendCode?`(${sendTime}s)`:''}}</a>
          </div>
          <van-number-keyboard
            v-model="postData.smscode"
            :show="showKeyboard"
            @blur="showKeyboard = false"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Register',
  components: {
    
  },
  props: ['recommendId'],
  data() {
    return {
      postData: {
        type: 'phone',
        dest: areaList[0].id,
        username: '',
        mail: '',
        password: '',
        re_password: '',
        smscode: '',
        code: '',
        code_rand: '',
        recommend: this.recommendId||''
      },
      recommendDis: this.recommendId?true:false,
      areaList: areaList,
      isSendCode: false,
      isSubmit: false,
      codeImg: '',
      showBrowserTips: false,
      downUrl: AppDown+'?lang='+this.$i18n.locale,
      isPlus: window.plus,
      showPopup: false,
      downTimer: null,
      sendTime: 60,
      tabsIndex: 'phone',
      showVerify: false,
      showKeyboard: false,
    }
  },
  computed: {
  
  },
  watch: {
    'postData.smscode'(val){
      if(val.length==6){
        this.showKeyboard = false
        this.onSubmit()
      }
    }
  },
  created() {
    if(this.$store.state.InitData.setting.reg_phone==0){
      this.postData.type = 'mail'
      this.tabsIndex = 'mail'
    }
    if(inviteCode){
      this.postData.recommend = inviteCode
      this.recommendDis = true
    }
    this.$Model.SmsCode((data) => {
      this.areaList = data
      this.postData.dest = data[0].id
    })
    // this.getCode()
    this.checkUserAgent()
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    clearInterval(this.downTimer)
  },
  methods: {
    changeTabs() {
      this.postData.type = this.tabsIndex
      this.postData.username = ''
      this.postData.mail = ''
      this.postData.smscode = ''
      this.isSendCode = false
      this.sendTime = 60
      clearInterval(this.downTimer)
      // this.getCode()
    },
    countDown() {
      this.downTimer = setInterval(()=>{
        this.sendTime --
        if(this.sendTime<0){
          this.isSendCode = false
          this.sendTime = 60
          clearInterval(this.downTimer)
        }
      },1000)
    },
    getMailCode() {
      this.postData.mail = this.postData.username
      if(!this.postData.mail){
        this.$Dialog.Toast(this.$t('Register[0]'));
        return;
      }
      if(!this.postData.password){
        this.$Dialog.Toast(this.$t('register.placeholder[2]'))
        return
      }
      if(!this.postData.recommend){
        this.$Dialog.Toast(this.$t('register.placeholder[4]'))
        return
      }
      this.isSendCode = true
      this.showVerify = true
      this.countDown()
      this.$Model.GetMailCode({mail: this.postData.mail, code: this.postData.code, code_rand: this.postData.code_rand,type: 'register'},(data)=>{
        if(data.code!=1){
          // this.getCode()
        }else{
          this.$Dialog.Alert(data.code_dec)
        }
      })
    },
    getCode() {
      this.postData.code_rand = new Date().getTime()
      this.codeImg = this.ApiUrl+'/api/Account/code?code_rand='+this.postData.code_rand
    },
    onSubmit() {
      if(this.tabsIndex=='mail'){
        this.postData.mail = this.postData.username
      }
      if(!this.postData.username){
        if(this.tabsIndex=='phone'){
          this.$Dialog.Toast(this.$t('register.placeholder[0]'))
        }else{
          this.$Dialog.Toast(this.$t('Register[0]'))
        }
        return
      }
      if(this.tabsIndex=='phone'&&!this.postData.smscode&&this.InitData.setting.is_sms==1){
        this.$Dialog.Toast(this.$t('register.placeholder[1]'))
        return
      }
      if(this.tabsIndex=='mail'&&!this.postData.smscode&&this.InitData.setting.is_mail==1){
        this.$Dialog.Toast(this.$t('Register[1][0]'))
        return
      }
      if(!this.postData.password){
        this.$Dialog.Toast(this.$t('register.placeholder[2]'))
        return
      }
      this.postData.re_password = this.postData.password
      // if(!this.postData.re_password){
      //   this.$Dialog.Toast(this.$t('register.placeholder[3]'))
      //   return
      // }
      // if(this.postData.password!=this.postData.re_password){
      //   this.$Dialog.Toast(this.$t('register.placeholder[5]'))
      //   return
      // }
      if(!this.postData.recommend){
        this.$Dialog.Toast(this.$t('register.placeholder[4]'))
        return
      }
      this.isSubmit = true
      this.$Model.UserRegister(this.postData,data=>{
        this.isSubmit = false
        // this.getCode()
      });
    },
    getSmsCode() {
      if(!this.postData.username){
        this.$Dialog.Toast(this.$t('register.placeholder[0]'))
        return
      }
      if(!this.postData.password){
        this.$Dialog.Toast(this.$t('register.placeholder[2]'))
        return
      }
      if(!this.postData.recommend){
        this.$Dialog.Toast(this.$t('register.placeholder[4]'))
        return
      }
      // if(!this.postData.code){
      //   this.$Dialog.Toast(this.$t('register.placeholder[6]'))
      //   return
      // }
      this.isSendCode = true
      this.showVerify = true
      this.countDown()
      this.$Model.GetSMSCode({phone: this.postData.username,dest: this.postData.dest, code: this.postData.code, recommend: this.postData.recommend, code_rand: this.postData.code_rand,type: 'register'},(data)=>{
        if(data.code!=1){
          // this.getCode()
        }else{
          this.$Dialog.Alert(data.code_dec)
        }
      })
    },
    checkUserAgent(callback) {
      var ua = navigator.userAgent;
      var is_WeiXin = ()=> {
        if (/(MicroMessenger)/.test(ua)) {
          return true;
        }
        return false;
      };
      var is_QQ = ()=> {
        if (/(QQ)/.test(ua)) {
          return true;
        }
        return false;
      };
      var is_Android = ()=> {
        if (/(Android)/.test(ua)) {
          return true;
        }
        return false;
      };
      var is_iOS = ()=> {
        if (/(iPod|iPhone|iPad)/.test(ua)) {
          return true;
        }
        return false;
      };
      if(is_WeiXin()){
        this.showBrowserTips = true;
      }
      if(is_iOS()){
        callback&&callback('IOS');
      }else{
        callback&&callback('Android');
      }
    },
  }
}
</script>

<style scoped>
.van-dropdown-menu>>>.van-dropdown-menu__bar{
  height: auto;
  box-shadow: none;
  background: transparent;
}
.van-dropdown-menu>>>.van-dropdown-menu__title{
  padding: 0 10px 0 0;
  margin-right: 10px;
  line-height: 1;
  font-size: inherit;
}
.van-dropdown-menu>>>.van-dropdown-item__content ul{
  padding: 0 15px;
}
.van-dropdown-menu>>>.van-dropdown-item__content ul li{
  padding: 8px 0;
  width: 100%;
  font-size: 14px;
}
.BrowserTips{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: right;
  z-index: 99999
}
.disclaimer-box{
  width: 100%;
  height: 100%;
}
.disclaimer-box>h2{
  font-size: 18px;
  padding: 15px;
  text-align: center;
}
.disclaimer-box .con{
  padding: 15px;
}
.verify-box>h2{
  padding: 20px 20px 0;
  font-weight: 600;
}
.verify-box>p{
  color: var(--color-assist);
  padding: 0 20px;
}
.verify-box .van-password-input{
  margin: 30px 20px 0;
}
.verify-box .van-password-input__item{
  background-color: var(--background-assist);
}
.verify-box .btn{
  margin: 15px 0 0 20px;
  display: inline-block;
  color: var(--color-active);
}
.verify-box .btn.disabled{
  color: var(--color-assist);
}
</style>